export default {
  listingSKU: {
    id: 'bo_seller.listings.listings_table.product_info.sku_label',
    defaultMessage: 'SKU: {sku}',
  },
  archiveListing: {
    id: 'listings_offer_archive',
    defaultMessage: 'Archive listing',
  },
  publishListing: {
    id: 'listings_offer_publish',
    defaultMessage: 'Publish listing',
  },
  publishing: {
    id: 'bo_seller.listings.listings_table.product_info.publishing',
    defaultMessage: 'Publishing...',
  },
  archiving: {
    id: 'bo_seller.listings.listings_table.product_info.archiving',
    defaultMessage: 'Archiving...',
  },
  newBattery: {
    id: 'listings-listing-special_offer-new_battery',
    defaultMessage: 'New battery',
  },
  gradeToolTip: {
    id: 'bo_seller.listings.listings_table.product_info.grade_tooltip',
    defaultMessage: 'Grade',
  },
  simToolTip: {
    id: 'bo_seller.listings.listings_table.product_info.sim_tooltip',
    defaultMessage: 'Supported SIM type',
  },
  dealOpportunity: {
    id: 'bo_seller.listings.listings_table.product_info.deal_opportunity',
    defaultMessage: 'Deal opportunity',
  },
} as const
